import { render, staticRenderFns } from "./#dimission.vue?vue&type=template&id=6498b2dd&"
import script from "./#dimission.vue?vue&type=script&lang=js&"
export * from "./#dimission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports